import LocalStorage from './localStorage';

export const apiUrl = process.env.REACT_APP_API_URL;
// export const apiUrl = 'https://uatapichopncisms.ril.com';
// console.log('URL', apiUrl);

const encodeQueryData = (data = null) => {
  if (data) {
    const ret = [];
    for (let d in data)
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    return '?' + ret.join('&');
  }
  return '';
};

const getLocalToken = () => {
  const user = LocalStorage.getItem('MAT-User');
  const authToken = user?.accessToken;
  if (authToken !== null && authToken !== '') {
    return `Bearer ${authToken}`;
  } else {
    return '';
  }
};

const apiClient = {
  Urls: {
    apiUrl,
    signin: `${apiUrl}/auth/verify-sign-in`,
    logout: `${apiUrl}/auth/sign-out`,
    otp: `${apiUrl}/auth/sign-in`,
    signupInfo: `${apiUrl}auth/create-user`,
    profiletypes: `${apiUrl}/masters/profile-types-list`,
    mastersdata: `${apiUrl}masters/`,
    aboutme_page: `${apiUrl}profile/about-me`,
    createdetails: `${apiUrl}profile`,
    listView: `${apiUrl}user/user-detail`,
    list_userView: `${apiUrl}user/user-payment-info`,
    dashboardViwa: `${apiUrl}dashboard/list-view`,
    dashboardAIView: `${apiUrl}gen-ai/ai-matches`,
    profileView: `${apiUrl}dashboard/detail-view`,
    profile_actions: `${apiUrl}action`,
    searchData: `${apiUrl}search/profiles`,
    user_actions: `${apiUrl}user`,
    profile_downloads: `${apiUrl}dashboard`,
    payment: `${apiUrl}payment`,
    feedbackData: `${apiUrl}feedback`,
    helpcenterData: `${apiUrl}helpcenter`,
    notifications: `${apiUrl}notification`,

    paymentdata: `${apiUrl}payment/create-order/`,
    paymentverify: `${apiUrl}payment/verify-payment/`
  },

  make: function (url, method, params, auth, type) {
    let headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    };

    let authHeaders = {
      Authorization: getLocalToken()
    };

    if (auth) {
      headers = {
        ...headers,
        ...authHeaders
      };
    }

    if (method == 'GET') {
      let queryParams = '';
      if (Object.keys(params || {}).length) {
        queryParams = encodeQueryData(params);
      }
      return fetch(url + queryParams, {
        method,
        headers
      })
        .then((response) => response.json())
        .catch((e) => e);
    } else {
      return fetch(url, {
        method,
        headers: type === 'file' ? authHeaders : headers,
        body: type === 'file' ? params : JSON.stringify(params)
      })
        .then((response) => response.json())
        .catch((e) => e);
    }
  },

  get: function (url, params, auth) {
    return apiClient.make(url, 'GET', params, auth);
  },

  post: function (url, params, auth, type) {
    return apiClient.make(url, 'POST', params, auth, type);
  },

  put: function (url, params, auth) {
    return apiClient.make(url, 'PUT', params, auth);
  },

  patch: function (url, params, auth) {
    return apiClient.make(url, 'PATCH', params, auth);
  },

  delete: function (url, params, auth) {
    return apiClient.make(url, 'DELETE', params, auth);
  }
};

export default apiClient;
